import { TimePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import ApontamentoMotivoParada from "model/meta/producao/ApontamentoMotivoParada";
import MotivoParada from "model/meta/producao/MotivoParada";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import ApontamentoMotivoParadaService from "service/meta/producao/ApontamentoMotivoParadaService";

type Props = {
    visible: boolean;
    onHide: () => void;
    value: ApontamentoMotivoParada;
    onConfirm: () => void;
}

const service = new ApontamentoMotivoParadaService();
export default function ModalEditarApontamentoParada(props: Props) {

    const { msgErro, msgSucesso, msgAlerta } = useToastContext();

    const [apontamento, setApontamento] = useState<ApontamentoMotivoParada>({ ...props.value });

    const [motivos, setMotivos] = useState<MotivoParada[]>([]);

    useEffect(() => {
        service.getMotivos().then((response) => {
            setMotivos(response);
        }).catch((err) => {
            console.error(err);
        });
    }, [])

    function validar() {
        if (!apontamento.motivoParada) {
            msgAlerta("Alerta", "Motivo de parada é obrigatório.");
            return false;
        }
        if (apontamento?.motivoParada?.controlaHorario) {
            if (apontamento.inicioParada == null) {
                msgAlerta("Alerta", "Horário de início da parada é obrigatório.");
                return false;
            }
            if (apontamento.fimParada !== null && apontamento.inicioParada > apontamento.fimParada) {
                msgAlerta("Alerta", "O horário de início não pode ser maior que o de fim.");
                return false;
            }
        }
        return true
    }

    const handleConfirm = () => {
        if (!validar()) {
            return;
        }
        service.editarApontamento(apontamento).then(() => {
            msgSucesso("Sucesso", "Apontamento de parada editado com sucesso.");
            props.onConfirm();
            props.onHide();
        }).catch((err) => {
            msgErro("Erro", err.data?.message || "Ocorreu um erro ao editar o apontamento de parada.");
            console.error(err);
        });

    }

    return (
        <Dialog
            header="Editar apontamento de parada"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Salvar" icon="pi pi-check" onClick={() => handleConfirm()} />
            </>}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Label obrigatorio >Motivo</Label>
                <Dropdown
                    value={apontamento.motivoParada}
                    filter
                    filterBy="descricao"
                    options={motivos}
                    onChange={(e) => {
                        if (!e.value.controlaHorario) {
                            apontamento.fimParada = null;
                        }
                        setApontamento({ ...apontamento, motivoParada: e.value })
                    }}
                    optionLabel="descricao"
                    placeholder="Selecione o motivo de parada"
                />
            </div>

            {apontamento.motivoParada?.controlaHorario ? <>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 16 }}>
                    <Label>Início da parada</Label>
                    <TimePicker
                        value={dayjs().hour(0).minute(apontamento.inicioParada ?? 0)}
                        slotProps={{
                            popper: {
                                disablePortal: true
                            }
                        }}
                        className="time-picker-horario"
                        timeSteps={{ minutes: 1 }}
                        onChange={(newValue) => {
                            apontamento.inicioParada = newValue ? ((newValue.hour() * 60) + newValue.minute()) : 0;
                            setApontamento({ ...apontamento });
                        }}
                    />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 16 }}>
                    <Label>Fim da parada</Label>
                    <TimePicker
                        value={dayjs().hour(0).minute(apontamento.fimParada ?? -1)}
                        slotProps={{
                            popper: {
                                disablePortal: true
                            }
                        }}
                        className="time-picker-horario"
                        timeSteps={{ minutes: 1 }}
                        onChange={(newValue) => {
                            apontamento.fimParada = newValue ? ((newValue.hour() * 60) + newValue.minute()) : 0;
                            setApontamento({ ...apontamento });
                        }}
                    />
                </div>
            </> : null}
        </Dialog>
    );

}